import { render, staticRenderFns } from "./ListChapters.vue?vue&type=template&id=fe915380&scoped=true&"
import script from "./ListChapters.vue?vue&type=script&lang=js&"
export * from "./ListChapters.vue?vue&type=script&lang=js&"
import style0 from "./ListChapters.vue?vue&type=style&index=0&id=fe915380&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe915380",
  null
  
)

export default component.exports